import React, { useState } from 'react';
import { database } from '../firebase'; // Import your Firebase setup

const CreateACM = () => {
    const [email, setEmail] = useState(''); // Renamed to email for clarity
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formattedEmail = email.replace(/[@.]/g, '_'); // Format email for database key
        const randomNickname = generateRandomNickname(); // Generate a random nickname

        try {
            await database.ref(`users/${formattedEmail}`).set({
                balance: 5.00,
                tier: 'Basic',
                nickname: randomNickname, // Add random nickname
                pronounscard: {
                    pronouns: ["000"], // Default pronouns
                    flags: ["000"],    // Default flags
                    timezone: "Demo",  // Default timezone
                    description: "Default description" // Default description
                },
                createdAt: new Date().toISOString(), // Track creation date
            });
            setMessage(`Child node created for email: ${email} with nickname: ${randomNickname}`);
            setEmail(''); // Clear the input
        } catch (error) {
            console.error('Error creating child node:', error);
            setMessage('Error creating child node.');
        }
    };

    // Function to generate a random nickname
    const generateRandomNickname = () => {
        const adjectives = ["Cool", "Bright", "Funny", "Silly", "Swift", "Amazing", "Gorgeous"];
        const nouns = ["Panda", "Tiger", "Eagle", "Shark", "Fox", "Bombay", "Zion", "Temasek"];
        const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
        const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
        return `${randomAdjective}${randomNoun}${Math.floor(Math.random() * 100)}`; // e.g., "CoolTiger23"
    };

    return (
        <div>
            <h1>Create User</h1>
            <form onSubmit={handleSubmit}>
                <div>
                    <label htmlFor="email">User Email:</label>
                    <input
                        type="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <button type="submit">Create</button>
            </form>
            <p>{message}</p>
        </div>
    );
};

export default CreateACM;
